import React, { FC } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import useDisclose from '~/hooks/useDisclose';
import PayrollCreateDrawer from '~/pages/payrolls/create/PayrollCreateDrawer';
import { usePermissions } from '~/hooks';

const PayrollCreateButton: FC = () => {
  const [t] = useTranslation('payrolls');
  const { isOpen, onOpen, onClose } = useDisclose(false);

  const hasAccessCreate = usePermissions('business.payrolls.create');
  if (!hasAccessCreate) return null;
  return (
    <>
      <Button onClick={onOpen} type="primary">
        {t('Run Payroll')}
      </Button>
      <PayrollCreateDrawer open={isOpen} onClose={onClose} />
    </>
  );
};

export default PayrollCreateButton;
